// extracted by mini-css-extract-plugin
module.exports = {"primaryBtn":"Button_primaryBtn__1AC4Z","primaryOutline":"Button_primaryOutline__2ShqC","spinner":"Button_spinner__8K6fs"};